import {provideRouter, Routes} from '@angular/router';
import {ApplicationConfig} from '@angular/core';
import {ErrorComponent} from 'src/app/pages/error/error.component';
import {CustomerComponent} from 'src/app/pages/customer/customer.component';
import {LookupComponent} from 'src/app/pages/lookup/lookup.component';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {credentialsInterceptor} from 'src/app/main/interceptors/credentials.interceptor';
import {RECAPTCHA_V3_SITE_KEY} from 'ng-recaptcha-2';
import {environment} from 'src/environments/environment';
import {DoiComponent} from 'src/app/pages/doi/doi.component';
import {RegistrationMainComponent} from '../pages/registration/registration-main/registration-main.component';
import {EweByMailComponent} from '../pages/wizards/ewe-by-mail/ewe-by-mail.component';
import {DigitalSignatureComponent} from '../pages/wizards/digital-signature/digital-signature.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ErrorComponent
      },
      {
        path: 'error',
        component: ErrorComponent,
      },
      {
        path: 'customer/:brand/:credentials',
        component: CustomerComponent,
      },
      {
        path: 'customer/:brand',
        component: CustomerComponent,
      },
      {
        path: 'lookup/:brand',
        component: LookupComponent,
      },
      {
        path: ':brand/lookup',
        component: LookupComponent,
      },

      {
        path: 'lookup',
        component: LookupComponent,
      },

      {
        path: 'doi/:verificationtoken',
        component: DoiComponent,
      },
      {
        path: 'doi/:brand/:verificationtoken',
        component: DoiComponent,
      },
      {
        path: ':brand/doi/:verificationtoken',
        component: DoiComponent,
      },
      {
        path: 'consentViaEmail/:brand/:verificationToken',
        component: EweByMailComponent,
      },
      {
        path: 'consentViaWizard/:brand',
        component: EweByMailComponent,
      },
      {
        path: 'digSig/:brand/:tecCustomerId/:dealerId/:interactionToken',
        component: DigitalSignatureComponent,
      },
      {
        path: 'registration',
        component: RegistrationMainComponent,
      },
      {
        path: 'registration/:brand',
        component: RegistrationMainComponent,
      },
    ]
  }
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([credentialsInterceptor])),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.sitekey }
  ]
}
